import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-input-multi-line",
  "use": "foquz-icon-input-multi-line-usage",
  "viewBox": "0 0 26 13",
  "content": "<symbol viewBox=\"0 0 26 13\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"foquz-icon-input-multi-line\"><path d=\"M4 5h18M4 8h12M3 12h20a2 2 0 002-2V3a2 2 0 00-2-2H3a2 2 0 00-2 2v7a2 2 0 002 2z\" stroke=\"currentColor\" stroke-width=\"2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol